module.exports = __webpack_public_path__ + "img/36.c4e8fcb2.gif";